import {lazy} from 'react';

export const HeroSearchLazy = lazy(() => import(/* webpackChunkName: "heroSearch" */ '.'));
